import React from 'react'

const Swarm = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 7.15706V10.3857L2.79821 12L5.59641 10.3855V7.15652L2.79821 5.5426L0 7.15706ZM9.20179 5.5426L6.40359 7.15695V10.3855L9.20179 12L12 10.3855V7.15641L9.20179 5.5426ZM8.79627 3.23161L7.39813 2.42174L7.39674 0.807605L6 0L3.20373 1.61446V4.84305L6 6.4574L8.79627 4.84305V3.23161Z" fill="currentColor"/>
    <path d="M8.79626 3.23161L10.1944 2.4212V0.807175L8.79841 0L7.39673 0.807605L8.79841 1.61295L8.79626 3.23161Z" fill="currentColor"/>
  </svg>
)
export default Swarm;